import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const CustomSection = memo(({ theme, sectionId }) => {
  const CustomLayout = dynamic(() => import(/* webpackChunkName: 'CustomSectionLayout' */ `../../../../../containers/home-page/views/sections/custom/layouts/${theme.layout}`))

  return (
    <CustomLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

CustomSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default CustomSection
